import _styled from "@emotion/styled-base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { SelectInput } from '@atlassian/mpac-ui';
import React from 'react';
const getHourOptions = () => {
  const options = [];
  for (let i = 0; i < 24; i++) {
    let value;
    if (i < 10) {
      value = '0' + i.toString();
    } else {
      value = i.toString();
    }
    options.push({
      label: value,
      value
    });
  }
  return options;
};
const TimeSelectContainer = _styled("div", {
  target: "ewu3uwq0",
  label: "TimeSelectContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "pi60e7",
  styles: "display:inline-block;max-width:150px;width:100%;margin:0px 10px;"
} : {
  name: "pi60e7",
  styles: "display:inline-block;max-width:150px;width:100%;margin:0px 10px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const CustomHoursSelection = _ref => {
  let {
    range
  } = _ref;
  const from = range === null || range === void 0 ? void 0 : range.from;
  const until = range === null || range === void 0 ? void 0 : range.until;
  const [fromHour, fromMinute] = from ? from.split(':') : ['00', '00'];
  const [untilHour, untilMinute] = until ? until.split(':') : ['00', '00'];
  const hourOptions = getHourOptions();
  const minuteOptions = [{
    label: '00',
    value: '00'
  }, {
    label: '30',
    value: '30'
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TimeSelectContainer, null, /*#__PURE__*/React.createElement(SelectInput, {
    name: "fromHour",
    label: "Start Time",
    options: hourOptions,
    defaultValue: {
      value: fromHour,
      label: fromHour
    }
  })), /*#__PURE__*/React.createElement(TimeSelectContainer, null, /*#__PURE__*/React.createElement(SelectInput, {
    name: "fromMinute",
    label: "",
    options: minuteOptions,
    defaultValue: {
      value: fromMinute,
      label: fromMinute
    }
  })), /*#__PURE__*/React.createElement("span", null, " : "), /*#__PURE__*/React.createElement(TimeSelectContainer, null, /*#__PURE__*/React.createElement(SelectInput, {
    name: "untilHour",
    label: "End Time",
    options: hourOptions,
    defaultValue: {
      value: untilHour,
      label: untilHour
    }
  })), /*#__PURE__*/React.createElement(TimeSelectContainer, null, /*#__PURE__*/React.createElement(SelectInput, {
    name: "untilMinute",
    label: "",
    options: minuteOptions,
    defaultValue: {
      value: untilMinute,
      label: untilMinute
    }
  })));
};
export default CustomHoursSelection;